import React from 'react';
import {
  MdAcUnit,
  MdBuild,
  MdChat,
  MdEditSquare,
  MdEmail,
  MdHistory,
  MdInfo,
  MdInsertDriveFile,
  MdKitchen,
  MdListAlt,
  MdMap,
  MdPeopleAlt,
  MdRoom,
  MdSchool,
  MdStore,
  MdStorefront,
  MdViewCarousel,
  MdOutlineViewCarousel,
  MdDeveloperMode,
  MdVerifiedUser,
  MdBarChart,
  MdCloudUpload,
  MdOutlineAccountTree,
  MdPhotoAlbum,
  MdFactCheck,
  MdPaid,
  MdWarehouse,
  MdCategory,
  MdOutlineCategory,
  MdStraighten,
  MdInventory2,
  MdShoppingCart,
  MdLabel,
  MdFlag,
} from 'react-icons/md';
import { FaArrowsSpin, FaBoxesPacking, FaUserGroup, FaUsersRectangle, FaWarehouse } from 'react-icons/fa6';
import { FaArrowAltCircleUp, FaBoxes, FaUserTimes } from 'react-icons/fa';

import { MenuCategory, ROLES } from './types';

const ALL: { all: true } = { all: true };

// Полный доступ для «обычных» ролей (без trade-marketing).
// Используется для разделов, недоступных роли trade-marketing.
const STANDARD: { roles: ROLES[] } = {
  roles: [ROLES.WORKER, ROLES.MANAGER, ROLES.ADMIN, ROLES.CHIEF],
};

const ADMIN_ONLY: { roles: ROLES[] } = {
  roles: [ROLES.ADMIN, ROLES.CHIEF],
};

export const menu: Array<MenuCategory> = [
  {
    id: 'guides_section',
    name: 'Справочники',
    children: [
      {
        id: 'equipments-guide',
        name: 'Справочник ТО',
        icon: MdAcUnit,
        to: '/equipments-guide',
        permissions: ALL,
      },
      {
        id: 'equipments-units',
        name: 'Справочники значений',
        icon: MdListAlt,
        to: '/equipments-units',
        permissions: ALL,
      },
      {
        id: 'agreements',
        name: 'Соглашения',
        icon: MdInsertDriveFile,
        to: '/agreements',
        permissions: ALL,
      },
      {
        id: 'equipments-model-guide',
        name: 'Модели стоек',
        icon: MdViewCarousel,
        to: '/equipments-stand-model-guide',
        permissions: ALL,
      },
      {
        id: 'equipments-dmp-groups',
        name: 'Группы ДМП',
        icon: FaBoxes,
        to: '/equipments-dmp-groups',
        permissions: ALL,
      },
      {
        id: 'equipments-dmp-types',
        name: 'Типы ДМП',
        icon: FaBoxesPacking,
        to: '/equipments-dmp-types',
        permissions: ALL,
      },
      {
        id: 'category-shelves',
        name: 'Категории полок',
        icon: MdListAlt,
        to: '/category_shelves',
        permissions: ALL,
      },
    ],
    permissions: STANDARD,
  },
  {
    id: 'distributors_section',
    name: 'Дистрибьюторы',
    children: [
      {
        id: 'distributors',
        name: 'Дистрибьюторы',
        icon: MdPeopleAlt,
        to: '/distributors',
        permissions: ALL,
      },
      {
        id: 'warehouses',
        name: 'Склады',
        icon: FaWarehouse,
        to: '/warehouses',
        permissions: ALL,
      },
      {
        id: 'warehouse-types',
        name: 'Типы складов',
        icon: MdWarehouse,
        to: '/warehouse-types',
        permissions: ALL,
      },
    ],
    permissions: STANDARD,
  },
  {
    id: 'equipments_section',
    name: 'Торговое оборудование',
    children: [
      {
        id: 'equipments',
        name: 'Оборудование',
        icon: MdKitchen,
        to: '/equipments',
        permissions: ALL,
      },
      {
        id: 'transactions',
        name: 'Транзакции',
        icon: FaArrowsSpin,
        to: '/equipments/transactions',
        permissions: ALL,
      },
      {
        id: 'equip_locations',
        name: 'Локации ТО',
        icon: MdRoom,
        to: '/equipments/locations',
        permissions: ALL,
      },
      {
        id: 'equip_import',
        name: 'Импорт данных ТО',
        icon: MdCloudUpload,
        to: '/equipments/imports',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'equip_stands',
        name: 'Стойки',
        icon: MdOutlineViewCarousel,
        to: '/equipments-stands',
        permissions: ALL,
      },
      // {
      //   id: 'equip_map',
      //   name: 'Карта',
      //   icon: MdMap,
      //   to: '/equipments-map',
      //   permissions: ALL,
      // },
      {
        id: 'service',
        name: 'Заявки на сервис',
        icon: MdBuild,
        to: '/equipments-repairs',
        permissions: ALL,
        counterId: 'repairs',
      },
      {
        id: 'paid-installations',
        name: 'Платные установки',
        icon: MdPaid,
        to: '/equipments/paid-installations',
        permissions: ALL,
      },
      {
        id: 'wiki',
        name: 'База знаний',
        icon: MdSchool,
        to: '/wiki',
        permissions: ALL,
      },
    ],
    permissions: STANDARD,
  },
  {
    id: 'active-customer-list',
    name: 'Активная клиентская база',
    children: [
      {
        id: 'outlets',
        name: 'Торговые точки',
        icon: MdStorefront,
        to: '/acl/outlets/?filter=%7B"status_id"%3A%7B"id"%3A1%2C"name"%3A"Открыта"%2C"is_default"%3Anull%7D%7D',
        permissions: ALL,
      },
      {
        id: 'new-outlets',
        name: 'Новые ТТ',
        icon: MdStore,
        to: '/acl/new-outlets/?sort=-id',
        permissions: STANDARD,
        counterId: 'new-outlets',
      },
      {
        id: 'updates-outlets',
        name: 'Изменения ТТ',
        icon: MdEditSquare,
        to: '/acl/updates-outlets/?sort=-id',
        permissions: ALL,
        counterId: 'updates-outlets',
      },
      {
        id: 'sub-channels',
        name: 'Каналы',
        icon: MdFactCheck,
        to: '/acl/sub-channels/',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'routes',
        name: 'Маршруты',
        icon: MdMap,
        to: '/acl/routes',
        permissions: { roles: [ROLES.ADMIN] },
      },
      {
        id: 'history',
        name: 'История изменений',
        icon: MdHistory,
        to: '/acl/history',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'import',
        name: 'Импорт новых ТТ',
        icon: MdCloudUpload,
        to: '/acl/import/outlets-create/',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'import',
        name: 'Импорт изменений ТТ',
        icon: MdCloudUpload,
        to: '/acl/import/outlets-update/',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'import-sales-source-outlets',
        name: 'Импорт источников продаж ТТ',
        icon: MdCloudUpload,
        to: '/acl/import/sales-source-outlets/',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
    ],
    permissions: ALL,
  },
  {
    id: 'sku',
    name: 'SKU',
    children: [
      {
        id: 'sku-management',
        name: 'Управление SKU',
        icon: MdInventory2,
        to: '/sku/management',
        permissions: STANDARD,
      },
      {
        id: 'sku-categories',
        name: 'Категории',
        icon: MdCategory,
        to: '/sku/categories',
        permissions: STANDARD,
      },
      {
        id: 'sku-subcategories',
        name: 'Подкатегории',
        icon: MdOutlineCategory,
        to: '/sku/subcategories',
        permissions: STANDARD,
      },
      {
        id: 'sku-units',
        name: 'Единицы измерения',
        icon: MdStraighten,
        to: '/sku/units',
        permissions: STANDARD,
      },
    ],
    permissions: ADMIN_ONLY,
  },
  {
    id: 'orders',
    name: 'Заказы',
    children: [
      {
        id: 'orders-list',
        name: 'Заказы',
        icon: MdShoppingCart,
        to: '/orders',
        permissions: STANDARD,
      },
      {
        id: 'orders-attributes',
        name: 'Атрибуты заказов',
        icon: MdLabel,
        to: '/orders/attributes',
        permissions: STANDARD,
      },
      {
        id: 'orders-statuses',
        name: 'Статусы заказов',
        icon: MdFlag,
        to: '/orders/statuses',
        permissions: STANDARD,
      },
    ],
    permissions: ADMIN_ONLY,
  },
  {
    id: 'org-structure',
    name: 'Структура организации',
    children: [
      {
        id: 'tree',
        name: 'Иерархия организации',
        icon: MdOutlineAccountTree,
        to: '/org-structure/tree/',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'employees',
        name: 'Сотрудники',
        icon: FaUserGroup,
        to: '/org-structure/employees/?filter=%7B"is_active"%3A"1"%7D',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'positions',
        name: 'Должности',
        icon: FaUsersRectangle,
        to: '/org-structure/positions/?filter=%7B"is_active"%3A"1"%7D',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'levels',
        name: 'Уровни организации',
        icon: FaArrowAltCircleUp,
        to: '/org-structure/levels/?filter=%7B"is_active"%3A"1"%7D',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
    ],
    permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
  },
  {
    id: 'reports',
    name: 'Отчетность',
    children: [
      {
        id: 'user-activity',
        name: 'Пользовательская активность',
        icon: MdVerifiedUser,
        to: '/reports/user-activity',
        permissions: ALL,
      },
      {
        id: 'scanning-report',
        name: 'Отчет по сканированию ХО',
        icon: MdBarChart,
        to: '/reports/scanning',
        permissions: ALL,
      },
      {
        id: 'tx-report',
        name: 'Отчет по установкам и демонтажам ХО',
        icon: MdBarChart,
        to: '/reports/transactions',
        permissions: ALL,
      },
      {
        id: 'stands-report',
        name: 'Отчет по стойкам',
        icon: MdBarChart,
        to: '/reports/stands',
        permissions: ALL,
      },
      {
        id: 'DMP-report',
        name: 'Отчет по ДМП',
        icon: MdBarChart,
        to: '/reports/dmp',
        permissions: ALL,
      },
      {
        id: 'activities-map',
        name: 'Карта активностей',
        icon: MdMap,
        to: '/reports/activities-map',
        permissions: { roles: [ROLES.ADMIN] },
      },
      {
        id: 'activities-gallery',
        name: 'Галерея активностей',
        icon: MdPhotoAlbum,
        to: '/reports/activities-gallery',
        permissions: { roles: [ROLES.ADMIN] },
      },
    ],
    permissions: STANDARD,
  },
  {
    id: 'help',
    name: 'Помощь',
    children: [
      {
        id: 'feedback-chat',
        name: 'Задать вопрос',
        icon: MdChat,
        to: '/help/feedback',
        permissions: ALL,
      },
      {
        id: 'support-chat',
        name: 'Чат с ассистентом',
        icon: MdChat,
        to: '/support-chat',
        permissions: ALL,
      },
    ],
    permissions: STANDARD,
  },
  {
    id: 'admin',
    name: 'Администрирование',
    children: [
      {
        id: 'history',
        name: 'История изменений',
        icon: MdHistory,
        to: '/history',
        permissions: { roles: [ROLES.ADMIN] },
      },
      {
        id: 'logs',
        name: 'Системные сообщения',
        icon: MdHistory,
        to: '/logs',
        permissions: { roles: [ROLES.ADMIN] },
      },
      {
        id: 'vars',
        name: 'Переменные системы',
        icon: MdInfo,
        to: '/vars',
        permissions: { roles: [ROLES.ADMIN] },
      },
      {
        id: 'mailing-lists',
        name: 'Email-рассылки',
        icon: MdEmail,
        to: '/mailing-lists',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'delivery-list',
        name: 'Данные SNEG-Delivery',
        icon: MdDeveloperMode,
        to: '/deliveries/list',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
      {
        id: 'delivery-list',
        name: 'Сессии SNEG-Delivery',
        icon: FaUserTimes,
        to: '/sessions/list',
        permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
      },
    ],
    permissions: { roles: [ROLES.ADMIN, ROLES.CHIEF] },
  },
];
